import { SxProps, Theme } from '@mui/material';

import { Button } from '@/components/form/baseInputs/Button/Button';
import { Highlighter02Icon } from '@/components/icons/Highlighter02Icon';
import { useHighlightButton } from '@/components/TextEditor/plugins/HighlightPlugin';
import { COLORS } from '@/styles/tokens/colors';

import { useSlideEditorToolbarContext } from './SlideEditor.toolbar';
import { SlideEditorToolbarPopover } from './SlideEditor.toolbarDropdown';

const DROPDOWN_KEY = 'highlight';

const OPEN_BUTTON_SX: SxProps<Theme> = {
  '&&': { bgcolor: COLORS.GRAY[100] },
};

/**
 * Highlight color dropdown for the slide editor toolbar. Behavior (selection
 * tracking, active-state, active-color background, color application) is
 * shared with other highlight buttons via `useHighlightButton`.
 */
export function SlideEditorHighlightButton() {
  const { activeDropdown, setActiveDropdown } = useSlideEditorToolbarContext();
  const { activeColorSx, menu } = useHighlightButton({
    isOpen: activeDropdown === DROPDOWN_KEY,
    onClose: () => setActiveDropdown(null),
  });

  return (
    <SlideEditorToolbarPopover
      dropdownKey={DROPDOWN_KEY}
      renderTrigger={({ isOpen }) => (
        <Button
          size="xs"
          variant="transparent"
          square
          // The active highlight color (when caret sits inside a highlight)
          // takes priority over the open-state pill so the button mirrors
          // the actual highlight color in the document.
          sx={activeColorSx ?? (isOpen ? OPEN_BUTTON_SX : undefined)}
        >
          <Highlighter02Icon size={16} />
        </Button>
      )}
    >
      {menu}
    </SlideEditorToolbarPopover>
  );
}
